import { Component, OnInit, Input, OnDestroy, AfterViewChecked } from '@angular/core';
import { BuscarPersona } from 'src/app/model/persons/buscarpersona.model';
import { AppComponent } from 'src/app/app.component';
import { PersonaService } from 'src/services/persona/persona.service';
import { SweetServices } from 'src/services/sweet.services';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { ComunicacionService } from 'src/services/comunicacion.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ExcelService } from 'src/services/persona/excel.service';
import Swal from 'sweetalert2';
import { TransaccionesService } from 'src/services/pld/transacciones.service';
import { Transacciones } from 'src/app/model/pld/transacciones.model';
import { AlertasService } from 'src/services/pld/alertas.service';

const moment = require('moment');

@Component({
  selector: 'app-transacciones-cliente',
  templateUrl: './transacciones-cliente.component.html',
  styleUrls: ['./transacciones-cliente.component.css']
})
export class TransaccionesClienteComponent implements OnInit, AfterViewChecked {

  // tslint:disable-next-line: no-input-rename

  personaResultados: [];
  reporteResultados: any[];
  total: number;
  totalRegistros: number;
  tipoPersonaCombo: number;
  numPage: number;
  contador: number;

  resultadoPaginadoTotal: [];
  transacciones: Transacciones;
  transaccionesResultados: [];

  /*Catalogos*/
  personalidadFiscal: [];
  estatus: [];
  sucursales: [];
  areas: [];

  constructor(
    private main: AppComponent,
    private personaService: PersonaService,
    private transaccionService: TransaccionesService,
    private alertaService: AlertasService,
    private alerta: SweetServices,
  ) {
    this.transacciones = new Transacciones();
    this.tipoPersonaCombo = 2;
    this.personaResultados = [];
    this.resultadoPaginadoTotal = [];
  }

  ngAfterViewChecked(): void {
    if (this.alertaService.persona === undefined) return;
    if (this.alertaService.buscando) return;

    this.buscarPersona();
  }

  ngOnInit() {
    this.main.loading = false;
    this.total = 0;
    this.totalRegistros = 0;
    this.numPage = 0;
    this.contador = 1;
  }

  onItemChange(checked, transaccion: any) {
    if (checked) {
      this.alertaService.transaccionesRelacionar.push(transaccion);
    } else {
      this.alertaService.transaccionesRelacionar = this.alertaService.transaccionesRelacionar.filter((value, index, arr) => {
        return Number(value.transaccionId) !== Number(transaccion.transaccionId);
      });
    }
  }

  paginador(value: boolean) {
    this.main.loading = true;
    if (value) {
      this.transacciones.Pagina++;
      this.contador++;
      this.buscarPersona();
    }

    if (!value) {
      this.transacciones.Pagina--;
      this.contador--;
      this.buscarPersona();
    }
  }

  buscarPersona() {
    console.log(1);

    this.main.loading = true;
    this.alertaService.buscando = true;
    this.transaccionesResultados = [];
    this.transacciones.ClienteId = this.alertaService.persona.personaId;

    var FORMATO_SALIDA = 'YYYY-MM-DD';
    var FORMATO_ENTRADA = 'YYYY-MM-DDTHH:mm:ss Z';
    var fechainicial = moment(new Date(1999, 1, 1), FORMATO_ENTRADA);
    var fechafinal = moment(new Date(2100, 1, 1), FORMATO_ENTRADA);
    this.transacciones.FechaInicial = fechainicial.format(FORMATO_SALIDA);
    this.transacciones.FechaFinal = fechafinal.format(FORMATO_SALIDA);

    this.transaccionService.buscarTransacciones(this.transacciones)
      .subscribe(response => {
        this.main.loading = false;
        if (response == null) {
          this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
        } else if (response.isCorrect == 'false') {
          this.transacciones.Pagina > 1 ? this.transacciones.Pagina-- : this.transacciones.Pagina = 1;
          this.alerta.AlertaError(response.message);
        } else if (response.data.total == 0) {
          this.alerta.AlertaSinResultados(response.message);
          this.transacciones.Pagina > 1 ? this.transacciones.Pagina-- : this.transacciones.Pagina = 1;
        } else {
          this.total = response.data.total;
          this.transaccionesResultados = response.data.info.result;
          this.totalRegistros = response.totalRegistros;
          this.numPage = Math.ceil(this.totalRegistros / 15);
        }
      }, (err) => {
        this.main.loading = false;
        if (err.error.message == null) {
          this.alerta.AlertaCatch(err);
        } else {
          this.alerta.AlertaError(err.error.message);
        }

      });
  }

}
